export const decrypt = (text) => {
  try {
    const decoded = decodeURIComponent(atob(text));
    return decoded.slice(0, -6);
  } catch {
    return text;
  }
};

const API_CONFIGS = {
  deepseek: {
    url: '/api/deepseek',
      headers: {
        'Content-Type': 'application/json',
      },
    formatRequest: (template) => ({
        model: "deepseek-chat",
      messages: [{ role: "user", content: template }],
        temperature: 0.7,
        max_tokens: 1000
    }),
    extractResponse: (data) => data.choices[0].message.content
  },
  
  openrouter: {
    url: 'https://openrouter.ai/api/v1',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${process.env.REACT_APP_OPENROUTER_API_KEY}`,
      'HTTP-Referer': window.location.origin,
      'X-Title': 'Cover Letter Generator'
    },
    formatRequest: (template) => ({
      model: "google/gemini-2.0-flash-lite-preview-02-05:free",
      messages: [{ role: "user", content: template }],
      temperature: 0.7,
      max_tokens: 1000
    }),
    extractResponse: (data) => data.choices[0].message.content
  }
};

export const generateCoverLetter = async (template) => {
  try {
    const currentProvider = process.env.REACT_APP_AI_PROVIDER || 'deepseek';
    const apiConfig = API_CONFIGS[currentProvider];

    if (!apiConfig) {
      throw new Error(`Unsupported AI provider: ${currentProvider}`);
    }

    const response = await fetch(apiConfig.url, {
      method: 'POST',
      headers: apiConfig.headers,
      body: JSON.stringify(apiConfig.formatRequest(template))
    });

    if (!response.ok) {
      const errorText = await response.text(); // Baca respons sebagai teks
      console.error('API Error Response:', errorText); // Cetak respons mentah
      throw new Error('Failed to generate content: ' + errorText);
    }

    const data = await response.json();
    return apiConfig.extractResponse(data);

  } catch (error) {
    console.error('Error generating content:', error);
    throw error;
  }
};